// extracted by mini-css-extract-plugin
module.exports = {"fields":"_AZWfM","mobile":"XyaF20"};